import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/services/toast.service';
import { DeadRetiredService } from './providers/dead-retired.service';

@Component({
    selector: 'app-retirecharacter',
    templateUrl: './retirecharacter.component.html',
    styleUrls: ['./retirecharacter.component.scss'],
    standalone: false
})
export class RetirecharacterComponent implements OnInit {
  @Input() character_id:any
  @Input() game_id:number
   retireFormGroup:FormGroup

  constructor(private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    private formBuilder:FormBuilder,
    private deadRetireService:DeadRetiredService,
    private toasterService: ToastService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void { 
    this.retireFormGroup = this.formBuilder.group({
      status_description:['',Validators.required],
      radio_choice:['',Validators.required]

    })
  }

  get RadioChoice() {
    return this.retireFormGroup.get('radio_choice');
  }

  // Close the modal programmatically
  closeModal(res?) {
    this.activeModal.close(res);
  }

  retireCharacter(){
    if(this.retireFormGroup.valid){
      const payload = {
        status_description:this.retireFormGroup.value.status_description,
      }
      if(this.retireFormGroup.value.radio_choice === 'is_retired' ){
        this.deadRetireService.retireCharacter(this.character_id,payload).subscribe((res:any)=>{
          if(res){
            
            this.toasterService.showSuccess(res.details || 'character retired successfully!!', 'success');
            this.cdr.detectChanges();
            this.closeModal(res);
          }
        },(error)=>{
          this.toasterService.showSuccess(error.error.error || 'Something Went Wrong !!!','danger')
        
          this.cdr.detectChanges();})
      }
      else{
        this.deadRetireService.markCharacterAsdead(this.character_id,payload).subscribe((res:any)=>{
          if(res){
            
            this.toasterService.showSuccess(res.details || 'character mark as dead successfully!!','success')
            this.closeModal(res)
          }
        
          this.cdr.detectChanges();},(error)=>{
          this.toasterService.showSuccess(error.error.error || 'Something Went Wrong !!!','danger')
        
          this.cdr.detectChanges();})
      }
    }
  }
}